import React from 'react';
import styled, { css } from 'styled-components';
import Button from '../../button/index';
import CalendarEvent from './calendar-event';

const ButtonsGrid = styled.div`
  display: inline-flex;
  flex-wrap: wrap;
  gap: 1rem;
  ${({ $justify }) => css`
    justify-content: ${$justify};
  `}
`;

const Buttons = ({
  className,
  justify,
  buttons,
  calendarEvents,
}) => (
  <ButtonsGrid className={className} $justify={justify}>
    {(buttons || []).map((button, index) => (
      <Button key={button.id} nth={index} {...button} />
    ))}
    {(calendarEvents || []).map((event, index) => (
      <CalendarEvent key={event.id} nth={index} {...event} />
    ))}
  </ButtonsGrid>
);

export default styled(Buttons)``;
